import { Button, Tooltip } from "@mui/material";
import { DataWrapper } from "../../../interfaces/DataWrapper";
import { PostPreference } from "../../../interfaces/PostPreference";
import NameHelper from "../../../helpers/name.helper";
import { Filters } from "../../../interfaces/Filters";
import classes from "./SaveFilters.module.scss";
import Notification from "../../../views/notification/Notification";
import useSavePreference from "../../../hooks/useSavePreference";
import { SavePreferenceConfig } from "../../../interfaces/SavePreferenceConfig";

const articleFiltersConfig: SavePreferenceConfig<Filters> = {
  buildPayload: (filters, userEmail): DataWrapper<PostPreference> => ({
    data: {
      name: NameHelper.createPreferenceNameFromFilters(filters),
      tags: filters.tags?.map((tag) => tag.id) ?? [],
      types: filters.types?.map((type) => type.id) ?? [],
      sites: filters.sites?.map((site) => site.id) ?? [],
      hasTips: filters.hasTips ?? false,
      user: userEmail,
      isForTipCollectionType: false,
      authors: []
    },
  }),
  messages: {
    saveTooltip:
      "By saving filters, you can create your own Personalized Filter Setup and receive Slack notifications.",
    error: "An error has occurred!",
    success:
      "Your Personalized Filter Setup is created! Go to profile page to subscribe for notifications!",
  },
};

const SaveFilters = ({
  filters,
  hidden,
}: {
  filters: Filters;
  hidden: boolean;
}) => {
  const {
    savePreferenceHandler,
    isSaveButtonDisabled,
    isNotificationOpen,
    notificationMessage,
    notificationSeverity,
    notificationCloseHandler,
    tooltipMessage,
  } = useSavePreference<Filters>(filters, articleFiltersConfig);

  return (
    <>
      <Tooltip title={tooltipMessage}>
        <Button
          className={`${classes["save-button"]} me-2`}
          disableElevation
          variant="contained"
          hidden={hidden}
          disabled={isSaveButtonDisabled}
          onClick={savePreferenceHandler}
        >
          Save filter
        </Button>
      </Tooltip>
      <Notification
        open={isNotificationOpen}
        onClose={notificationCloseHandler}
        message={notificationMessage}
        severity={notificationSeverity}
        position={{ vertical: "top", horizontal: "right" }}
      />
    </>
  );
};

export default SaveFilters;
